import { useContext } from "react";

import { MapStore } from "../stores/map";

export default function useMapStore() {
  return useContext(MapStore);
}
